import Status from '@/pages/statusAdmin/StatusAdmin.page'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/status-editor')({
  component: () => <StatusLayout />,
})

const StatusLayout = () => {
  return (
    <>
      <Status />
      <Outlet />
    </>
  )
}
